import styled from "styled-components";
import gqricon, {
  ReactComponent as PlatformIcon,
} from "modules/ui/assets/PlatformLogo.svg";

export const Icon = styled(PlatformIcon)`
  font-size: 18px !important;
`;
